import { useStoreSelector } from '../../../core/store/selector.js';
import { SankeyHoverStoreContext } from '../context/SankeyHoverStore.context.js';
import type { SankeyHoverState } from '../types/sankey-hover.js';

/**
 * Compares by reference rather than deeply: a hovered shape holds layout nodes
 * whose `sourceLinks`/`targetLinks` reference back into the whole graph, so a
 * deep comparison would traverse it on every pointer move. Writers only publish
 * a new shape when the hovered identity actually changes.
 */
export const useSankeyHoverSelector = <T>(
  selector: (state: SankeyHoverState) => T,
): T => useStoreSelector(SankeyHoverStoreContext, selector);

export const useSankeyHoveredShape = () =>
  useSankeyHoverSelector((state: SankeyHoverState) => state.hovered);
